import { defineNuxtPlugin } from '#app/nuxt'
import { LazyLayoutPageContent, LazyLayoutPageFooter, LazyLayoutPageHeader, LazyLayoutPageNavbar, LazyLayoutPageNavbarDropdownThemeSwitcher, LazyLayoutPageNavbarMenuItem, LazyLayoutPageNavbarMenuWrapper, LazyLayoutPageSectionTitle, LazyLayoutPageSection, LazyLayoutPageTitle, LazyLayoutPageWrapper, LazyAwesomeActionSheetGroup, LazyAwesomeActionSheetHeader, LazyAwesomeActionSheetHeaderMessage, LazyAwesomeActionSheetHeaderTitle, LazyAwesomeActionSheetItem, LazyAwesomeActionSheetItemButton, LazyAwesomeActionSheet, LazyAwesomeAlertBanner, LazyAwesomeButton, LazyAwesomeCardContent, LazyAwesomeCardFooter, LazyAwesomeCardTitle, LazyAwesomeCard, LazyAwesomeContentDoc, LazyAwesomeContentRenderer, LazyAwesomeError, LazyAwesomeFormSwitch, LazyAwesomeFormTextInput, LazyAwesomeLink, LazyAwesomeTab, LazyAwesomeTabs, LazyAwesomeWelcome, LazyBusinessDialog, LazyConsultationDialog, LazyLanguageSwitcher, LazyMachineModel, LazyMoleculeScene, LazyParticleRingScene, LazyParticleStar, LazyParticleTerrain, LazyToast, LazyWaveGridBackground, LazyFenziTest, LazyHalo, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["LayoutPageContent", LazyLayoutPageContent],
["LayoutPageFooter", LazyLayoutPageFooter],
["LayoutPageHeader", LazyLayoutPageHeader],
["LayoutPageNavbar", LazyLayoutPageNavbar],
["LayoutPageNavbarDropdownThemeSwitcher", LazyLayoutPageNavbarDropdownThemeSwitcher],
["LayoutPageNavbarMenuItem", LazyLayoutPageNavbarMenuItem],
["LayoutPageNavbarMenuWrapper", LazyLayoutPageNavbarMenuWrapper],
["LayoutPageSectionTitle", LazyLayoutPageSectionTitle],
["LayoutPageSection", LazyLayoutPageSection],
["LayoutPageTitle", LazyLayoutPageTitle],
["LayoutPageWrapper", LazyLayoutPageWrapper],
["AwesomeActionSheetGroup", LazyAwesomeActionSheetGroup],
["AwesomeActionSheetHeader", LazyAwesomeActionSheetHeader],
["AwesomeActionSheetHeaderMessage", LazyAwesomeActionSheetHeaderMessage],
["AwesomeActionSheetHeaderTitle", LazyAwesomeActionSheetHeaderTitle],
["AwesomeActionSheetItem", LazyAwesomeActionSheetItem],
["AwesomeActionSheetItemButton", LazyAwesomeActionSheetItemButton],
["AwesomeActionSheet", LazyAwesomeActionSheet],
["AwesomeAlertBanner", LazyAwesomeAlertBanner],
["AwesomeButton", LazyAwesomeButton],
["AwesomeCardContent", LazyAwesomeCardContent],
["AwesomeCardFooter", LazyAwesomeCardFooter],
["AwesomeCardTitle", LazyAwesomeCardTitle],
["AwesomeCard", LazyAwesomeCard],
["AwesomeContentDoc", LazyAwesomeContentDoc],
["AwesomeContentRenderer", LazyAwesomeContentRenderer],
["AwesomeError", LazyAwesomeError],
["AwesomeFormSwitch", LazyAwesomeFormSwitch],
["AwesomeFormTextInput", LazyAwesomeFormTextInput],
["AwesomeLink", LazyAwesomeLink],
["AwesomeTab", LazyAwesomeTab],
["AwesomeTabs", LazyAwesomeTabs],
["AwesomeWelcome", LazyAwesomeWelcome],
["BusinessDialog", LazyBusinessDialog],
["ConsultationDialog", LazyConsultationDialog],
["LanguageSwitcher", LazyLanguageSwitcher],
["MachineModel", LazyMachineModel],
["MoleculeScene", LazyMoleculeScene],
["ParticleRingScene", LazyParticleRingScene],
["ParticleStar", LazyParticleStar],
["ParticleTerrain", LazyParticleTerrain],
["Toast", LazyToast],
["WaveGridBackground", LazyWaveGridBackground],
["FenziTest", LazyFenziTest],
["Halo", LazyHalo],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
